import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, NumberValue } from '@jutro/components';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useTranslator } from '@jutro/locale';
import _ from 'lodash';
import metadata from './StateFeesComponent.metadata.json5';
import styles from './StateFeesComponent.module.scss';
import messages from './StateFeesComponent.messages';

const stripRatingTerms = (displayName) => {
    const ratingExpression = /\s*\((.*?)\)\s*/g;
    return displayName.replace(ratingExpression, '');
};

function itemizedFeesTemplate(totalFees, itemizedFees, translator) {
    const feesRows = itemizedFees.map((fee, index) => {
        const displayName = stripRatingTerms(fee.feeDisplayName);

        return (
            <div className="state-fees vertical-spacing-10" key={displayName}>
                <p className="body-copy state-fees-right-rail">{displayName}</p>
                <p className="body-copy state-fees-right-rail">
                    <NumberValue
                        format="#.##"
                        id={`feeAmount${index}`}
                        prefix="$"
                        tag="span"
                        value={fee.amount.toFixed(2)}
                    />
                </p>
            </div>
        );
    });
    return (
        <div>
            <p className="body-copy state-fees-right-rail font-weight-bold vertical-spacing-10">
                {translator(messages.totalFees)}
                <NumberValue
                    format="#.##"
                    id="totalFeeItem"
                    prefix="$"
                    tag="span"
                    value={_.get(totalFees, 'amount', 0).toFixed(2)}
                />
            </p>
            { feesRows }
        </div>
    );
}


function ItemizedFeesTooltipComponent(props) {
    ItemizedFeesTooltipComponent.propTypes = {
        totalFees: PropTypes.shape({
            amount: PropTypes.number
        }).isRequired,
        itemizedFees: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
        displayAlternativeTemplate: PropTypes.bool.isRequired,
        translator: PropTypes.func.isRequired
    };

    const {
        totalFees,
        itemizedFees,
        displayAlternativeTemplate,
        translator
    } = props;
    return (
        <Tooltip
            id="tooltipFees"
            placement="bottom"
            trigger="click"
            content={itemizedFeesTemplate(totalFees, itemizedFees, translator)}
        >
            {displayAlternativeTemplate
                ? (
                    <span className={styles.feesTooltip}>
                        <NumberValue
                            format="#.##"
                            id="totalFeesVal"
                            prefix="$"
                            tag="span"
                            value={_.get(totalFees, 'amount', 0).toFixed(2)}
                            className={styles.feeDetails}
                        />
                        &nbsp;
                        <i className="icon-ml-carrot-down-outline" />
                    </span>
                ) : (
                    <span className={styles.feeDetails}>
                        {translator(messages.feeDetails)}
                    </span>
                )
            }
        </Tooltip>
    );
}

function StateFeesComponent(props) {
    const translator = useTranslator();

    const {
        totalFees,
        itemizedFees,
        displayAlternativeTemplate
    } = props;

    const overrides = {
        itemizedfeestooltipcomponent: {
            totalFees: totalFees,
            itemizedFees: itemizedFees,
            displayAlternativeTemplate,
            translator: translator
        },
        totalFeesSpan: {
            visible: displayAlternativeTemplate
        },
        includedInPremiumSpan: {
            visible: displayAlternativeTemplate
        }
    };

    const resolvers = {
        resolveComponentMap: {
            itemizedfeestooltipcomponent: ItemizedFeesTooltipComponent
        },
        resolveClassNameMap: styles
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
}

StateFeesComponent.propTypes = {
    totalFees: PropTypes.shape({}).isRequired,
    itemizedFees: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    displayAlternativeTemplate: PropTypes.bool,
};

StateFeesComponent.defaultProps = {
    displayAlternativeTemplate: false
};

export default StateFeesComponent;
